import(/* webpackMode: "eager", webpackExports: ["MobileNav"] */ "/home/ubuntu/routerbench_new/apps/ui/src/components/models/mobile-nav.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/routerbench_new/node_modules/.pnpm/next@16.1.1_@babel+core@7.28.5_@opentelemetry+api@1.9.0_babel-plugin-react-compiler@1.0_6d9e40018215248210ec78c841d5abba/node_modules/next/dist/client/app-dir/link.js");
